import ChipComponentRequisitionStatus from '@/components/chip/ChipComponentRequisitionStatus';
import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'code',
        headerName: 'Mã phiếu',
        editable: false,
        sortable: true,
        minWidth: 70,
        flex: 0.5,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => <HoverCopyCell value={params.row.code} />,
    },
    {
        field: 'assigneeName',
        headerName: 'Người đề xuất',
        editable: false,
        sortable: false,
        minWidth: 120,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.taskCheck?.assigneeName}>
                <EntityDetailButton
                    text={params.row.taskCheck?.assigneeName}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.assigneeId}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'customer',
        headerName: 'Khách hàng',
        editable: false,
        minWidth: 200,
        sortable: false,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.taskCheck?.ticket?.customer?.name}>
                <EntityDetailButton
                    text={params.row.taskCheck?.ticket?.customer?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.ticket?.customer?.id}
                    type='CUSTOMER'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.CUSTOMER],
    },
    {
        field: 'requisitionDate',
        headerName: 'Ngày tạo',
        editable: false,
        minWidth: 120,
        sortable: true,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell
                value={dateUtils.getDate(params.row.requisitionDate)}
            />
        ),
    },
    {
        field: 'oppCode',
        headerName: 'Mã OPP',
        editable: false,
        minWidth: 100,
        sortable: false,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.oppCode} />,
    },
    {
        field: 'partRequisitionStatus',
        headerName: 'Trạng thái',
        editable: false,
        sortable: false,
        minWidth: 120,
        flex: 1,
        renderCell: params => (
            <ChipComponentRequisitionStatus
                status={params.row.partRequisitionStatus}
                size='small'
            />
        ),
    },
];
